// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"87c2542d","453":"3bfd6d03","508":"c6467987"}[chunkId] + ".chunk.js";
};